import { AlertCircle, CalendarClock, FileClock, MailQuestion } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface PendingAction {
  label: string;
  count: number;
  description: string;
}

interface PendingActionsCardsProps {
  data: PendingAction[];
}

const icons = [FileClock, MailQuestion, AlertCircle, CalendarClock];

export function PendingActionsCards({ data }: PendingActionsCardsProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Pending Actions</CardTitle>
        <CardDescription>
          Candidates that need follow-up from the hiring team
        </CardDescription>
      </CardHeader>
      <CardContent className="grid gap-4 sm:grid-cols-2">
        {data.length === 0 ? (
          <div className="text-sm text-muted-foreground">No pending actions</div>
        ) : (
          data.map((item, index) => {
            const Icon = icons[index % icons.length];

            return (
              <div key={item.label} className="rounded-lg border bg-muted/20 p-4">
                <div className="mb-3 flex items-start justify-between gap-3">
                  <div>
                    <div className="text-sm font-medium leading-5">{item.label}</div>
                    <div className="mt-1 text-xs text-muted-foreground">
                      {item.description}
                    </div>
                  </div>
                  <Icon className="h-4 w-4 text-muted-foreground" />
                </div>
                <div className="text-2xl font-semibold">{item.count}</div>
              </div>
            );
          })
        )}
      </CardContent>
    </Card>
  );
}
